import React, { Component } from 'react';
import BasicInfo from './BasicInfo';
import { Form, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import Compressor from 'compressorjs';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { createRide } from '../../actions/rideManagementActions';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class CreateBoat extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subCategory: "",
            title: "",
            subTitle: "",
            description: "",
            priceD: undefined,
            address: "",
            make: "",
            model: "",
            motor: "",
            horsepower: undefined,
            fuelType: "",
            year: undefined,
            width: "",
            length: "",
            sleepCapacity: undefined,
            washrooms: false,
            trailer: false,
            captain: false,
            image: undefined
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.onImageChange = this.onImageChange.bind(this);
        this.oncategoryChange = this.oncategoryChange.bind(this);
        this.onsubCategoryChange = this.onsubCategoryChange.bind(this);
        this.ontitleChange = this.ontitleChange.bind(this);
        this.onsubTitleChange = this.onsubTitleChange.bind(this);
        this.ondescriptionChange = this.ondescriptionChange.bind(this);
        this.onpriceDChange = this.onpriceDChange.bind(this);
        this.onaddressChange = this.onaddressChange.bind(this);
        this.onmakeChange = this.onmakeChange.bind(this);
        this.onmodelChange = this.onmodelChange.bind(this);
        this.onmotorChange = this.onmotorChange.bind(this);
        this.onhorsepowerChange = this.onhorsepowerChange.bind(this);
        this.onfuelTypeChange = this.onfuelTypeChange.bind(this);
        this.onyearChange = this.onyearChange.bind(this);
        this.onwidthChange = this.onwidthChange.bind(this);
        this.onlengthChange = this.onlengthChange.bind(this);
        this.onsleepCapacityChange = this.onsleepCapacityChange.bind(this);
        this.onwashroomsChange = this.onwashroomsChange.bind(this);
        this.ontrailerChange = this.ontrailerChange.bind(this);
        this.oncaptainChange = this.oncaptainChange.bind(this);
    }
    onSubmit(values) {
        values.preventDefault();
        const { user } = this.props;
        const address = this.state.address;
        const self = this;
        let data = {
            typeGroup: this.props.typeGroup,
            image: this.state.image,
            type: this.state.subCategory,
            title: this.state.title,
            subtitle: this.state.subTitle,
            description: this.state.description,
            ownerId: this.props.user.userProfile.sub,
            priceD: this.state.priceD,
            state: "online",
            details: JSON.stringify({
                make: this.state.make,
                model: this.state.model,
                motor: this.state.motor,
                horsepower: this.state.horsepower,
                fuelType: this.state.fuelType,
                year: this.state.year,
                width: this.state.width,
                length: this.state.length,
                sleepCapacity: this.state.sleepCapacity,
                washrooms: this.state.washrooms,
                trailer: this.state.trailer,
                captain: this.state.captain
            })
        }
        new Compressor(this.state.image, {
            quality: 0.2,
            success(result) {
                geocodeByAddress(address).then(
                    (info) => {
                        let city = ""
                        let province = ""
                        let fullAddress = info[0].formatted_address
                        info[0].address_components.forEach((elem) => {
                            if (elem.types[0] === "locality") {
                                city = elem.long_name
                            }
                            if (elem.types[0] === "administrative_area_level_1") {
                                province = elem.short_name
                            }
                        })
                        getLatLng(info[0]).then(
                            (res) => {
                                const geoLocal = {
                                    latitude: res.lat,
                                    longitude: res.lng
                                }
                                data.image = result;
                                data.fullAddress = fullAddress;
                                data.geoLocalLat = geoLocal.latitude;
                                data.geoLocalLng = geoLocal.longitude;
                                data.city = `${city}, ${province}`;
                                const form_data = new FormData()
                                for (var key in data) {
                                    form_data.append(key, data[key])
                                }
                                createRide(form_data, user.token).then((res) => {
                                    self.setState({
                                        success: true
                                    })
                                })
                            }
                        )
                    }
                )
            },
            error(err) {
                console.log(err.message);
            },
        });
    }

    oncategoryChange(data) {
        this.setState({
            category: data.target.value
        })
    }

    onsubCategoryChange(data) {
        this.setState({
            subCategory: data.target.value
        })
    }

    ontitleChange(data) {
        this.setState({
            title: data.target.value
        })
    }

    onsubTitleChange(data) {
        this.setState({
            subTitle: data.target.value
        })
    }

    ondescriptionChange(description) {
        this.setState({
            description
        })
    }

    onpriceDChange(data) {
        this.setState({
            priceD: data.target.value
        })
    }

    onaddressChange(address) {
        this.setState({
            address
        })
    }

    onmakeChange(data) {
        this.setState({
            make: data.target.value
        })
    }

    onmodelChange(data) {
        this.setState({
            model: data.target.value
        })
    }

    onmotorChange(data) {
        this.setState({
            motor: data.target.value
        })
    }

    onhorsepowerChange(data) {
        this.setState({
            horsepower: data.target.value
        })
    }

    onfuelTypeChange(data) {
        this.setState({
            fuelType: data.target.value
        })
    }

    onyearChange(data) {
        this.setState({
            year: data.target.value
        })
    }

    onwidthChange(data) {
        this.setState({
            width: data.target.value
        })
    }

    onlengthChange(data) {
        this.setState({
            length: data.target.value
        })
    }

    onsleepCapacityChange(data) {
        this.setState({
            sleepCapacity: data.target.value
        })
    }

    onwashroomsChange() {
        this.setState({
            washrooms: !this.state.washrooms
        })
    }

    ontrailerChange() {
        this.setState({
            trailer: !this.state.trailer
        })
    }

    oncaptainChange() {
        this.setState({
            captain: !this.state.captain
        })
    }

    onImageChange(event) {
        event.preventDefault();
        this.setState({
            image: event.target.files[0]
        })
    }

    render() {
        if (this.state.success) {
            return <Redirect to="/rider" />
        }
        return (
            <Form onSubmit={this.onSubmit}>
                <Row>
                    <Col>
                        <Form.Group as={Col} controlId="formGridState">
                            <Form.Label className="createride__category__title">Sub Category</Form.Label>
                            <Form.Control name="type" as="select" onChange={this.onsubCategoryChange}>
                                <option></option>
                                <option value="motorBoat">Bateaux à moteur</option>
                                <option value="fishingBoat">Bateaux de pêche</option>
                                <option value="sailingBoat">Bateaux à voile</option>
                                <option value="watercraft">Moto-marines</option>
                                <option value="yatchs">Yatchs</option>
                                <option value="other">Autres bateaux</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>

                {/* BASIC INFORMATION */}
                <BasicInfo
                    ontitleChange={this.ontitleChange}
                    onsubTitleChange={this.onsubTitleChange}
                    ondescriptionChange={this.ondescriptionChange}
                    onpriceDChange={this.onpriceDChange}
                    onaddressChange={this.onaddressChange}
                    address={this.state.address}
                />
                {/* SPEFICICATIONS */}

                <Form.Label className="createride__category__title">Specifications</Form.Label>

                <div className="createride__specifications__grid">
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Make</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="make" type="text" placeholder="Make" onChange={this.onmakeChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Model</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="model" type="text" placeholder="Model" onChange={this.onmodelChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Motor</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="motor" type="text" placeholder="Motor" onChange={this.onmotorChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Horsepower</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="horsepower" type="number" placeholder="Horsepower" onChange={this.onhorsepowerChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Fuel Type</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="fuelType" type="text" placeholder="Fuel Type" onChange={this.onfuelTypeChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Year</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="year" type="number" placeholder="Year" onChange={this.onyearChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Width (5'11)</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="width" type="text" placeholder="Width" onChange={this.onwidthChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Length (5'11)</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="length" type="text" placeholder="Length" onChange={this.onlengthChange} />
                        </InputGroup>
                    </div>
                    <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Sleep Capacity</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control name="sleepers" type="number" placeholder="Sleep Capacity" onChange={this.onsleepCapacityChange} />
                        </InputGroup>
                    </div>
                </div>
                <Row>
                    <Col>
                        <Form.Group id="formGridCheckbox" className="createride__checkboxes">
                            <Form.Check name="washrooms" inline type="checkbox" label="Washrooms? " onChange={this.onwashroomsChange} />
                            <Form.Check name="trailer" inline type="checkbox" label="Trailer Included?" onChange={this.ontrailerChange} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group id="formGridCheckbox" className="createride__checkboxes">
                            <Form.Check name="captain" inline type="checkbox" label="Is this a Captain Package?" onChange={this.oncaptainChange} />
                            {/* <Form.Label className="createride__category__title">Is this a Captain Package?</Form.Label> */}
                        </Form.Group>
                    </Col>
                </Row>

                {/* PICTURES AND SUBMIT */}
                <Row>
                    <Col>
                        {/* <Field name="image" accept='.jpg, .png, .jpeg' component={FieldFileInput} /> */}
                        <Form.Label className="createride__category__title">Upload Pictures</Form.Label>
                        <Form.Control name="image" accept='.jpg, .png, .jpeg' type="file" onChange={this.onImageChange} />
                    </Col>
                </Row>
                <Button variant="primary" type="submit">
                    Create Ride
                </Button>
            </Form>
        )
    }
}

export default connect((state) => {
    return { user: state.reducerUser }
})(CreateBoat);